import { api } from '@/services';

export interface SimplesNacionalFiltro {
  entrada_saida: number;
  codigoModelo: string;
  cnpj_contribuinte: string;
  data_emissao_de: string;
  data_emissao_ate: string;
  status: string;
  pagina_numero: number;
  pagina_quantidade_por: number;
}

export interface SimplesNacionalDocumento {
  Modelo: string;
  CodigoModelo: string;
  ChaveAcessoDOC: string;
  Numero: string;
  Data: string;
  CNPJ: string;
  RazaoSocial: string;
  CFOP?: string;
  vNF: string;
  Status: string;
  // Tributos (opcionais — retornados pela API mas ausentes em mocks/outros modelos)
  CST?: string;
  cClassTrib?: string;
  BaseCalculo?: string;
  AliquotaICMS?: string;
  ValorICMS?: string;
  AliquotaPIS?: string;
  ValorPIS?: string;
  AliquotaCOFINS?: string;
  ValorCOFINS?: string;
  AliquotaIBSUF?: string;
  ValorIBSUF?: string;
  AliquotaIBSMun?: string;
  ValorIBSMun?: string;
  AliquotaCBS?: string;
  ValorCBS?: string;
}

export interface SimplesNacionalGrupo {
  modelo: string;
  codigoModelo: string;
  totalItens: number;
  data: SimplesNacionalDocumento[];
}

export interface ListaDocumentosSimplesResponse {
  status: { resultado: boolean; mensagem: string };
  data: SimplesNacionalGrupo[];
}

export async function fetchListaDocumentosSimples(
  filtro: SimplesNacionalFiltro
): Promise<ListaDocumentosSimplesResponse> {
  return api.post<ListaDocumentosSimplesResponse, SimplesNacionalFiltro>(
    'TurboPro/SimplesNacional/ListaDocumentos',
    filtro
  );
}
